const BoxEntity = ({ icon, content, value, date }) => {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", gap: "4px" }}>
        <div
          style={{
            width: "18%",
            height: "46px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {icon && (
            <img
              src={icon}
              alt="icon"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "fill",
              }}
            />
          )}
        </div>
        <div
          style={{
            width: "60%",
            height: "46px",
            whiteSpace: "pre",
            display: "flex",
            alignItems: "center",
            lineHeight: "17px",
          }}
        >
          {content}
        </div>
        <div
          style={{
            width: "22%",
            height: "46px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-end",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          {value[0] && <span>{value[0]}</span>}
          {value[1] && <span style={{ fontSize: "12px" }}>{value[1]}</span>}
        </div>
      </div>
      {date && <div>{`${date}`}</div>}
    </>
  );
};
export default BoxEntity;
